import { render, staticRenderFns } from "./InsectMonitorHistory.vue?vue&type=template&id=f34cc15c&scoped=true&"
import script from "./InsectMonitorHistory.vue?vue&type=script&lang=ts&"
export * from "./InsectMonitorHistory.vue?vue&type=script&lang=ts&"
import style0 from "./InsectMonitorHistory.vue?vue&type=style&index=0&id=f34cc15c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34cc15c",
  null
  
)

export default component.exports